import { MenuItem } from "@/components/shared/MenuItem/component";
import { formatCustomerAccountNumber } from "@/helpers/account/formatCustomer/utils";
import { formatLocalDate } from "@/utils/date/utils";

import { CELL_WIDTH, PAYER_TABLE_COLUMNS } from "./constants";
import type {
  FromTidAccountsToColumnsParams,
  FromTidAccountsToRowsParams,
} from "./types";

export const fromTidAccountsToColumns = ({
  items,
  tCompanies,
}: FromTidAccountsToColumnsParams) => {
  if (items.length === 0) {
    return [];
  }

  const columns = PAYER_TABLE_COLUMNS.map((key) => ({
    identifier: key,
    cellWidth: CELL_WIDTH[key],
    columnName: tCompanies(`companies.tid.payer.table.columns.${key}`),
    displayedByDefault: true,
    dataTestId: `accounts__account-details-tid-payer_${key}-column_title`,
  }));

  return [
    ...columns,
    {
      identifier: "context-menu",
      columnName: "",
      displayedByDefault: true,
      dataTestId: `accounts__account-details-tid-payer_context-menu-column_title`,
    },
  ];
};

export const fromTidAccountsToRows = ({
  items,
  tCompanies,
  locale,
  navigate,
  onDelete,
}: FromTidAccountsToRowsParams) =>
  items.map((item, index) => ({
    key: item.id,
    id: item.id,
    data: {
      companyName: (
        <span
          data-testid={`accounts__account-details-tid-payer_companyName-${item.id}`}
        >
          {item.companyName || "-"}
        </span>
      ),
      accountNumber: (
        <span
          data-testid={`accounts__account-details-tid-payer_accountNumber-${item.id}`}
        >
          {item.accountNumber
            ? formatCustomerAccountNumber(item.accountNumber)
            : "-"}
        </span>
      ),
      type: (
        <span
          data-testid={`accounts__account-details-tid-payer_type-${item.id}`}
        >
          {item.type
            ? tCompanies(`companies.list.type.${item.type}.label`)
            : "-"}
        </span>
      ),
      updatedTs: (
        <span
          data-testid={`accounts__account-details-tid-payer_updatedTs-${item.id}`}
        >
          {item.updatedTs ? formatLocalDate(item.updatedTs, locale) : "-"}
        </span>
      ),
    },
    contextMenuDataTestId: `accounts__account-details-tid-payer_${index}-context-menu`,
    menuItems: [
      {
        key: `accounts__account-details-tid-payer_${index}-context-menu-showCard-button`,
        dataTestId: `accounts__account-details-tid-payer_${index}-context-menu-showCard-button`,
        onClick: () => {
          if (item.linkedAccountId) {
            navigate({
              to: "/account/$id",
              params: { id: item.linkedAccountId },
            });
          }
        },
        children: (
          <MenuItem text={tCompanies("companies.tid.payer.actions.go")} />
        ),
      },
      ...(item.type === "CUSTOM_PAYER"
        ? [
            {
              key: `accounts__account-details-tid-payer_${index}-context-menu-delete-button`,
              dataTestId: `accounts__account-details-tid-payer_${index}-context-menu-delete-button`,
              onClick: () => {
                if (item.linkedAccountId) {
                  onDelete(item.linkedAccountId);
                }
              },
              children: (
                <MenuItem
                  type='danger'
                  text={tCompanies("companies.tid.payer.actions.delete")}
                />
              ),
            },
          ]
        : []),
    ],
  }));
